import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Paper } from '@mui/material'

const useStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
    maxWidth: 1600,
    maxHeight: '100%',
    overflowY: 'auto',
    margin: '0 auto',
    padding: theme.spacing(4),
    transition: 'max-width 0.3s ease-in-out',
    '&::-webkit-scrollbar': {
      WebkitAppearance: 'none',
      width: 6,
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey.grey03,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3),
    },
  },
}))

interface Props {
  activeStep: number
  content: React.ReactNode
}

/**
 * Displays the content of a wizard's step
 */
const WizardContent: React.VFC<Props> = ({ activeStep, content }) => {
  const { classes } = useStyles()

  const isStepWithNarrowContent = [4, 5].includes(activeStep)

  return (
    <Paper className={classes.container} style={{ maxWidth: isStepWithNarrowContent ? 600 : 1200 }}>
      {content}
    </Paper>
  )
}

export default WizardContent
